module.exports = __webpack_public_path__ + "img/PA272481.1c50430b.jpg";